import Amplify, { Auth, API } from 'aws-amplify';

//
Amplify.configure({
	Auth: {
		// REQUIRED only for Federated Authentication - Amazon Cognito Identity Pool ID
		identityPoolId: 'eu-central-1:bdb4c13c-5649-4b9f-9ad5-8a95f8d170d4',

		// REQUIRED - Amazon Cognito Region
		region: 'eu-central-1',

		// OPTIONAL - Amazon Cognito Federated Identity Pool Region
		// Required only if it's different from Amazon Cognito Region
		//identityPoolRegion: "XX-XXXX-X",

		// OPTIONAL - Amazon Cognito User Pool ID
		userPoolId: 'eu-central-1_Ci4Cpphk2',

		// OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
		userPoolWebClientId: '20091pd6pm700iddp8nsjuu1hn'

		// OPTIONAL - Enforce user authentication prior to accessing AWS resources or not
		//mandatorySignIn: false,

		// OPTIONAL - Configuration for cookie storage
		// Note: if the secure flag is set to true, then the cookie transmission requires a secure protocol
		/* cookieStorage: {
			// REQUIRED - Cookie domain (only required if cookieStorage is provided)
			domain: ".yourdomain.com",
			// OPTIONAL - Cookie path
			path: "/",
			// OPTIONAL - Cookie expiration in days
			expires: 365,
			// OPTIONAL - Cookie secure flag
			// Either true or false, indicating if the cookie transmission requires a secure protocol (https).
			secure: true
		} */

		// OPTIONAL - customized storage object
		//storage: new MyStorage(),

		// OPTIONAL - Manually set the authentication flow type. Default is 'USER_SRP_AUTH'
		//authenticationFlowType: "USER_PASSWORD_AUTH"
	},
	API: {
		endpoints: [
			{
				name: 'MyCognitoSecuredResourceServer',
				endpoint: 'https://lmpxvaqdk7.execute-api.eu-central-1.amazonaws.com/develop/foos'
			},
			{
				name: 'MyExpressServer',
				endpoint: 'http://localhost:8000/api'
			}
		]
	}
});

const AmplifyWrapper = {
	/**
     * 
     */
	currentAuthenticatedUser() {
		return Auth.currentAuthenticatedUser({
			bypassCache: true // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
		});
	},

	/**
     * 
     * @param {*} username 
     * @param {*} password 
     * @param {*} email 
     * @param {*} phoneNumber 
     */
	signUp(username, password, email, phoneNumber) {
		return Auth.signUp({
			username: username,
			password: password,
			attributes: {
				email: email, // optional
				phone_number: phoneNumber // optional - E.164 number convention
				// other custom attributes
			},
			validationData: [] //optional
		});
	},

	/**
     * 
     * @param {*} username 
     * @param {*} code 
     * @param {*} options 
     */
	confirmSignUp(username, code, options = {}) {
		options = {
			forceAliasCreation: true // Optional. Force user confirmation irrespective of existing alias.
		};
		return Auth.confirmSignUp(username, code, options);
	},

	/**
     * 
     * @param {} username 
     */
	resendSignUp(username) {
		return Auth.resendSignUp(username);
	},

	/**
     * 
     * @param {*} username 
     * @param {*} password 
     */
	signIn(username, password) {
		//TODO. see SignIn.js
	},

	/**
     * MFA 
     * 
     * @param {*} user 
     * @param {*} code 
     * @param {*} mfaType 
     */
	confirmSignIn(user, code, mfaType) {
		return Auth.confirmSignIn(
			user, // Return object from Auth.signIn()
			code, // Confirmation code
			mfaType // MFA Type e.g. SMS_MFA, SOFTWARE_TOKEN_MFA
		);
	},

	/**
     * 
     */
	signOut() {
		return Auth.signOut();
	},

	/**
     * 
     * @param {*} username 
     */
	forgotPassword(username) {
		return Auth.forgotPassword(username);
	},

	/**
     * 
     * @param {*} username 
     * @param {*} code 
     * @param {*} newPassword 
     */
	forgotPasswordSubmit(username, code, newPassword) {
		return Auth.forgotPasswordSubmit(username, code, newPassword);
	},

	/**
     * 
     * @param {*} attrName 
     */
	verifyCurrentUserAttribute(attrName) {
		return Auth.verifyCurrentUserAttribute(attrName);
	},

	/**
     * 
     * @param {*} attrName 
     * @param {*} value 
     */
	verifyCurrentUserAttributeSubmit(attrName, value) {
		return Auth.verifyCurrentUserAttributeSubmit(attrName, value);
	},

	/**
     * 
     * @param {*} type 
     * @param {*} details 
     * @param {*} user 
     */
	federatedSignIn(type, details, user) {
		return Auth.federatedSignIn(type, details, user);
	},

	// - -

	/**
     * 
     * @param {*} method 
     * @param {*} apiName 
     * @param {*} path 
     * @param {*} cfg 
     */
	makeApiRequest(method, apiName, path, cfg) {
		return API[method](apiName, path, cfg);
	}
};

export default AmplifyWrapper;
